
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/pregnancy",
      function () {
        return require("private-next-pages/health-insurance/pregnancy/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-insurance/pregnancy"])
      });
    }
  